import cookieConsent from "../cookie-consent";
import cookieConsentInitializer from "../cookie-consent/cookieConsentInitializer";
import registerGlobal from "../utils/registerGlobal";
import privacyConsent from "../privacy-consent";
import privacyConsentInitializer from "../privacy-consent/privacyConsentInitializer";

const packageName = "ux-ui-cookie-consent";

const addPackageScripts = (): void => {
    const bundleFilename = `${packageName}.min.js`;
    const bundleScriptNode = document.querySelector<HTMLScriptElement>(
        `script[src*="/${bundleFilename}"]`,
    ) as HTMLScriptElement;
    if (!bundleScriptNode) {
        throw new Error(
            `Could not find script tag with src containing "/${bundleFilename}". Please make sure to include the bundle script before this script.`,
        );
    }

    const baseUrl =
        bundleScriptNode
            .getAttribute("src")
            ?.split("/")
            .slice(0, -1)
            .join("/") || "";

    const esmModuleScriptNode = document.createElement("script");
    esmModuleScriptNode.src = `${baseUrl}/${packageName}/${packageName}.esm.js`;
    esmModuleScriptNode.type = "module";
    bundleScriptNode.insertAdjacentElement("afterend", esmModuleScriptNode);

    const noModuleScriptNode = document.createElement("script");
    noModuleScriptNode.src = `${baseUrl}${packageName}/${packageName}.js`;
    noModuleScriptNode.noModule = true;
    esmModuleScriptNode.insertAdjacentElement("afterend", noModuleScriptNode);
};

addPackageScripts();

registerGlobal(cookieConsent, ["trumpf", "ux", "uiCookieConsent"], window);
cookieConsentInitializer();

registerGlobal(privacyConsent, ["trumpf", "ux", "uiPrivacyConsent"], window);
privacyConsentInitializer();
